import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import phoneSvg from '../../assets/gfx/phone.svg';
import lockSvg from '../../assets/gfx/lock.svg';
import SecurePopup from './securePopup';
import { phoneNumber } from '../../helpers/locationHelper';


class HeaderPayment extends PureComponent{

  constructor(){
    super();
    this.state = {
      ISOCurrencyCode:'',
      secureIsOpen:false
    }
    this.onSecureHandler = this.onSecureHandler.bind(this);
    this.documentClickHandler = this.documentClickHandler.bind(this);
  }

  documentClickHandler(e){
   try{
      if(e.target.offsetParent.className !== "row secure-wrapper"){
        this.setState({secureIsOpen:false});
      }
    }catch(e){}
  }

  componentDidMount(){
    document.body.addEventListener('click', this.documentClickHandler);
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }


  componentDidUpdate(prevProps, prevState) {
    if(this.props.currency !== prevProps.currency){
      this.setState({ISOCurrencyCode:this.props.currency.iso_currency_code});
    }
  }


  onSecureHandler(){
    this.setState({secureIsOpen:!this.state.secureIsOpen});
  }

  render(){

    const { secureIsOpen, ISOCurrencyCode } = this.state;

    return(
      <div className="header-payment"
        id="header-payment">
        <div className="row">
          <div className="column small-12">
            <ul>
              <li>
                <a href={`tel:${phoneNumber(true, ISOCurrencyCode)}`}>
                  <img src={phoneSvg} alt="phone icon" />
                  {phoneNumber(false, ISOCurrencyCode)}
                </a>
              </li>
              <li onClick={this.onSecureHandler}>
                <img src={lockSvg} alt="lock icon" />
                Secure booking
              </li>
            </ul>
          </div>
         </div>


         <div style={{display:secureIsOpen ? 'block' : 'none'}} className="row secure-wrapper">
          <div className="column small-12">
             <SecurePopup secureLocation="header"/>
           </div>
         </div>

      </div>
    )
  }

}

function mapStateToProps(state){
  return {
    currency:state.currency
  }
}

export default connect(mapStateToProps, null)(HeaderPayment);



// WEBPACK FOOTER //
// ./src/components/shared/payment.js